<template>
    <div class="vod-status-view">
        <img src="@/assets/img/logos/vod_logo.svg" v-if="type == 'success'" />
        <div class="lottie-animation">
            <lottie-animation v-if="type == 'error'" path="lottie/error.json" />
        </div>
        <div class="vod-status-message">
            <h2>{{ header }}</h2>
            <p>{{ body }}</p>
        </div>
        <ActionButton
            @click="proceed"
            color="apple"
            :label="$t('BUTTON_CONTINUE_LONG')"
        />
    </div>
</template>
<script>
export default {
    data() {
        return {
            type: '',
            body: ''
        }
    },
    computed: {
        header() {
            return this.type == 'success'
                ? this.$t('LABEL_SUCCESS')
                : this.$t('TOAST_ERROR_TITLE')
        }
    },
    methods: {
        proceed() {
            if (this.type == 'success') {
                this.$store.commit('setSidebarForm', 'login')
            }
            this.$router.push('/')
        },
        setMessage() {
            switch (this.$route.params.type) {
                case 'reset_password_success':
                    this.type = 'success'
                    this.body = this.$t('LABEL_NEW_PASSWORD_SENT')
                    break
                case 'reset_password_failure':
                    this.type = 'error'
                    this.body = this.$t('LABEL_RESET_SUCCESS')
                    break
                case 'confirm_account_success':
                    this.type = 'success'
                    this.body =
                        'Udało się aktywować Twoje konto! Możesz się teraz zalogować.'
                    break
                case 'confirm_account_failure':
                    this.type = 'error'
                    this.body = this.$t('LABEL_ACTIVATE_ERRROR')
                    break
                case 'signup_success':
                    this.type = 'success'
                    this.body = this.$t(
                        'TOAST_MESSAGE_SIGNUP_SUCCESS_MAIL_LEFT'
                    )
                    break
                case 'unknown_error':
                    this.type = 'error'
                    this.body = this.$t('API_UNKNOWN_ERROR')
                    break
            }
        }
    },
    mounted() {
        this.setMessage()
    }
}
</script>
<style lang="scss" scoped>
.vod-status-view {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 5rem;
    color: var(--color);

    img {
        height: 5rem;
    }
}
.vod-status-message {
    width: 30%;
    font-size: 1.5rem;
    margin-top: 1rem;
}
.lottie-animation {
    width: 15%;
}
@media (max-width: 1000px) {
    .vod-status-view {
        padding: 2rem;
        padding-top: 5rem;
    }
    .vod-status-message {
        width: 100%;
    }
    .lottie-animation {
        width: 50%;
    }
}
</style>
